import InputDate from "./inputDate";

export default InputDate;